import { footerData } from "@/mocks/homeData";

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500 text-xl"></i>
              </span>
              <span className="text-foreground-50 font-heading text-base">{footerData.siteName}</span>
            </div>
            <p className="text-primary-500 text-xs font-medium mb-3">{footerData.slogan}</p>
            <p className="text-foreground-600 text-xs leading-relaxed">{footerData.desc}</p>
          </div>

          <div>
            <h3 className="text-foreground-300 text-sm font-medium mb-3">快速导航</h3>
            <div className="grid grid-cols-2 gap-2">
              {footerData.links.map((link) => (
                <a
                  key={link.text}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-foreground-600 hover:text-primary-500 text-xs transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.text}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-foreground-300 text-sm font-medium mb-3">合作伙伴</h3>
            <p className="text-foreground-700 text-xs leading-relaxed">优质影视内容合作方持续入驻中，欢迎各大内容平台联系合作。</p>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/30 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-foreground-700 text-xs">{footerData.copyright}</p>
          <p className="text-foreground-700 text-xs">本站所有内容均来自互联网，仅供交流学习使用</p>
        </div>
      </div>
    </footer>
  );
}